import { Box, Image } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import sigliveCuriosity from 'Asset/image/siglive-curiosity.svg';
import { TextBold, TextRegular } from 'UiKit/typography';

import styles from './styles.module.css';

const DataNotFound = ({ className, background, height, fieldSearch = '' }) => {
  const { t } = useTranslation('empty-state');

  return (
    <Box className={`${styles['not-found__container']} ${className}`} background={background} height={height}>
      <Box className={styles['not-found__content']}>
        <Box className={styles['not-found__icon-wrapper']}>
          <Image src={sigliveCuriosity} alt="No data found" />
        </Box>

        <TextBold className={styles['not-found__title']}>{fieldSearch ? t('by_search.title', { itemName: fieldSearch }) : t('by_filter.title')}</TextBold>

        <TextRegular className={styles['not-found__description']}>{fieldSearch ? t('by_search.description') : t('by_filter.description')}</TextRegular>
      </Box>
    </Box>
  );
};

export default DataNotFound;
